import { render, staticRenderFns } from "./BpCrowdPizza.vue?vue&type=template&id=d7b42cf8&"
import script from "./BpCrowdPizza.vue?vue&type=script&lang=js&"
export * from "./BpCrowdPizza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports